import { useState } from "react";
import airplaneImage1 from "../assets/images/airplane-1.png";
import airplaneImage2 from "../assets/images/airplane-2.png";
import airplaneImage3 from "../assets/images/airplane-3.png";
import airplaneImage4 from "../assets/images/airplane-4.png";
import Slider from "../../../components/ui/Slider";
import TransportCard from "./TransportCard";

interface Props {
  className?: string;
}

type TransportCardType = {
  id: string;
  title: string;
  description: string;
  imageSrc: string;
  skillLevel: number;
};

const TransportCardsList = ({ className = "" }: Props) => {
  const [transportCards /*setTransportCards */] = useState<TransportCardType[]>(
    [
      {
        id: "1",
        title: "Transport commercial",
        description: "Lorem ipsum dolar sit amet, consectetur adipiscing elit.",
        skillLevel: 6,
        imageSrc: airplaneImage1,
      },
      {
        id: "2",
        title: "Transport AGRICULTURAL",
        description: "Lorem ipsum dolar sit amet, consectetur adipiscing elit.",
        skillLevel: 8,
        imageSrc: airplaneImage2,
      },
      {
        id: "3",
        title: "Transport Cloud seeding",
        description: "Lorem ipsum dolar sit amet, consectetur adipiscing elit.",
        skillLevel: 6,
        imageSrc: airplaneImage3,
      },
      {
        id: "4",
        title: "Transport ILLEGAL",
        description: "Lorem ipsum dolar sit amet, consectetur adipiscing elit.",
        skillLevel: 6,
        imageSrc: airplaneImage4,
      },
    ]
  );
  const [selected, setSelected] = useState(new Set());

  return (
    <div
      className={`grid grid-cols-4 gap-3 justify-center  w-fit mx-auto  ${className}`}
    >
      {transportCards?.map((item, i) => (
        <TransportCard
          key={item.id}
          isHighlighted={i === 1}
          {...item}
          isSelected={selected.has(item.id)}
          onSelect={() => {
            setSelected((prevSelected) => {
              const newSelected = new Set(prevSelected);
              if (newSelected.has(item.id)) {
                newSelected.delete(item.id);
              } else {
                newSelected.add(item.id);
              }
              return newSelected;
            });
          }}
        />
      ))}
    </div>
  );

  /* if yo uwant slider and more cards */
  return (
    <Slider className={`${className}`}>
      <div className="flex items-center space-x-3 py-5">
        {transportCards?.map((item, i) => (
          <TransportCard
            key={item.id}
            isHighlighted={i === 1}
            {...item}
            isSelected={selected.has(item.id)}
            onSelect={() => {
              setSelected((prevSelected) => {
                const newSelected = new Set(prevSelected);
                if (newSelected.has(item.id)) {
                  newSelected.delete(item.id);
                } else {
                  newSelected.add(item.id);
                }
                return newSelected;
              });
            }}
          />
        ))}
      </div>
    </Slider>
  );
};

export default TransportCardsList;
